// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__6VctN","filesListContainer":"PosDisputesFiles_filesListContainer__3jZOw","filesButton":"PosDisputesFiles_filesButton__TY45X"};